<template>
  <a :href="model.link" class="cards__card">
    <div class="card__content">
      <div class="content__image">
        <div class="image__image">
          <img v-if="model.image" :src="model.image.split('|')[0]" :alt="model.image.split('|')[1]" />
        </div>
      </div>
      <div class="content__text">
        <div class="content__title">
          <div class="heading epsilon m-group-title">{{ model.type }}</div>
          <div class="model-title">{{ model.title }}</div>
        </div>
        <div class="content__details">
          <div class="details__detail" v-for="(attribute, index) in model.attributes" :key="index">
            <div class="detail__title">
              <span class="bold">{{ attribute.title }}</span>
              <template v-if="attribute.type === 'icons'">
                <span class="info__point icon-info-before"></span>
                <div class="info__box">
                  <div class="box__content">
                    <div class="content__details">
                      <div class="detail__icon" v-for="(item, idx) in attribute.values" :key="idx">
                        <img v-if="item.icon" :src="item.icon.split('|')[0]" :alt="item.icon.split('|')[1]" />
                        <span>{{ item.title }}</span>
                      </div>
                    </div>
                    <div class="box__arrow"></div>
                  </div>
                </div>
              </template>
            </div>
            <div class="detail__value" v-if="attribute.type === 'text'">
              <span>{{ attribute.values.map(value => value.title).join(', ') }}</span>
            </div>
            <div class="detail__icons" v-else>
              <div class="model-icon" v-for="(item, idx) in attribute.values" :key="idx">
                <img v-if="item.icon" :src="item.icon.split('|')[0]" :alt="item.icon.split('|')[1]" />
              </div>
            </div>
          </div>
          <div class="details__detail">
            <div class="detail__title">
              <span class="bold">{{ $t('results.model.attributes.id.label') }}</span>
            </div>
            <div class="detail__value">
              <span>{{ model.id }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a>
</template>
<script>
import { computed } from 'vue'

export default {
  name: "productCard",
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  setup () {
    const link = computed(() => {
      // remove api from end of window.app.api_base and add /model-detail
      return window.app.model_list.api_base.replace(/\/api/, '') + '/model-detail'
    })
    return { link }
  },
}

</script>
